import { Subject } from '@enmon/commons/lib/enmon';
import { Resource } from '@enmon/commons/lib/shared/permissions';

export const getResourceFromSubject = (subject: Subject) => {
  switch (subject) {
    case Subject.Customers:
      return Resource.Customers;
    case Subject.Establishments:
      return Resource.Establishments;
    case Subject.Meters:
      return Resource.Meters;
    case Subject.SupplyPoints:
      return Resource.SupplyPoints;
    case Subject.Users:
      return Resource.Users;
    case Subject.Invoices:
      return Resource.Invoices;
    case Subject.SensorConsumptionRecords:
    case Subject.SensorValueRecords:
    case Subject.ManualRecords:
      return Resource.Readings;
    case Subject.Tenants:
      return Resource.Tenants;
    default:
      return null;
  }
};
